import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'

import CommentSection from './CommentSection'
import RelatedVideos from './RelatedVideos'
import SharePopup from './SharePopup'

import {
  ReactComponent as ShareIcon,
} from '../../assets/svg/icon-share.svg'

import './styles/single-video.scss'
import { updateViewsCount } from '../../utils/api'


const SingleVideo = props => {

  const {
    id,
    snippet: {
      publishedAt,
      description,
      title,
      resourceId: {
        videoId,
      },
    }, views, tags, comments,
  } = props

  const [isDescVisible, setIsDescVisible] = useState(true)
  const [isSharePopupVisible, setIsSharePopupVisible] = useState(false)
  const [videoTags, setVideoTags] = useState([])
  const [videoComments, setVideoComments] = useState(comments)

  const toggleDescription = () => {
    setIsDescVisible(!isDescVisible)
  }

  useEffect(() => {
    setVideoTags(tags)
  }, [tags])

  useEffect(() => {
    updateViewsCount(videoId).then(e => console.log('View registered', e))
  }, [videoId])

  return (
    <div className="single-video">
      <h1 className="section-title">now playing</h1>
      <div className="container">
        <div className="main-content">
          <section className="video-player">
            <div className="video-player__video-container">
              <iframe
                src={`https://youtube.com/embed/${videoId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={title}>
              </iframe>
            </div>
            <div className="video-player__meta-container">
              <h2 className="title">
                {title}
              </h2>
              <div className="meta-group">
                <p className="views-count highlighted">{views} views</p>
                <p className="published">
                  Published&nbsp;
                  <time dateTime={publishedAt}>
                    {format(new Date(publishedAt), 'MMMM dd, yyyy')}
                  </time>
                </p>
                {/* TODO: implement if time available... */}
                <button
                  type="button"
                  className="share"
                  onClick={() => setIsSharePopupVisible(!isSharePopupVisible)}
                >
                  <ShareIcon className="icon"/>
                  <span>
                    share
                  </span>
                </button>
                {description.length !== 0 && (
                  <button
                    type="button"
                    className="toggle-description"
                    onClick={toggleDescription}
                    aria-label="Toggle description"
                  >
                    {isDescVisible ? 'Hide' : 'Show'} description
                  </button>
                )}
              </div>
              {isDescVisible && description.length !== 0 && (
                <div className="description">
                  <hr className="separator"/>
                  <p>
                    {description}
                  </p>
                </div>
              )}
            </div>
          </section>
          <CommentSection comments={videoComments} setComments={setVideoComments} videoId={videoId}/>
        </div>
        <RelatedVideos tags={videoTags} currentVideoId={id}/>
      </div>
      {isSharePopupVisible && (
        <SharePopup setIsVisible={setIsSharePopupVisible} videoID={videoId}/>
      )}
    </div>
  )
}

export default SingleVideo